import $ from 'jquery';
import Vue from 'vue';

if($('#vue-wow-search-form-f').length){

  window.WowSearchHomeA = new Vue({
    el: '#vue-wow-search-form-f',
    data: {
      formData: {
        t: 'adv',
        pricemin: null,
        pricemax: null,
        filter_stayday: '',
        filter_months: '',
      },
      filter_price: '',
    },
    created: function () {
      const params = this.getParams();
      if(params.filter_stayday) this.formData.filter_stayday = params.filter_stayday;
      if(params.filter_months)  this.formData.filter_months = params.filter_months;
      if(params.pricemin && params.pricemax) {
        this.filter_price = [params.pricemin, params.pricemax].join('-');
      }
    },
    watch: {
      filter_price: function(val) {
        [this.formData.pricemin, this.formData.pricemax] = val.split('-');
      }
    },
    methods: {
      getParams: function (url = window.location.href) {
        var params = {};
        var parser = document.createElement('a');
        parser.href = url;
        var query = parser.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split('=');
          params[pair[0]] = decodeURIComponent(pair[1]);
        }
        return params;
      },
      onSubmit: function () {
        const data = this.formData;
        for (const propName in data) { 
          if (data[propName] === null || data[propName] === '' || data[propName] === undefined) {
            delete data[propName];
          }
        }
        location.href = ($('base').attr('href') || '') + '/search-tour/?' + $.param(data);
      },
    },
    mounted: function () {
    },
  });

}

$('.js-wow-from-hight').click(function(){
  $(this).addClass('wow-search-form-f__form-height-block');
});
$('.js-wow-close-btn').click(function(e){
  e.stopPropagation();
  $('.js-wow-from-hight').removeClass('wow-search-form-f__form-height-block');
});